// @ts-nocheck
import React from "react";
import { Typography } from "@mui/material";
import ReactECharts from "echarts-for-react";

const lineOption = {
  title: { text: "Line Chart", textStyle: { color: '#fff' } },
  tooltip: { backgroundColor: '#222', textStyle: { color: '#fff' }, borderColor: '#fff' },
  xAxis: { data: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"], axisLabel: { color: '#fff' }, axisLine: { lineStyle: { color: '#fff' } } },
  yAxis: { axisLabel: { color: '#fff' }, axisLine: { lineStyle: { color: '#fff' } } },
  series: [
    { name: "uv", type: "line", data: [4000, 3000, 2000, 2780, 1890, 2390, 3490] },
    { name: "pv", type: "line", data: [2400, 1398, 9800, 3908, 4800, 3800, 4300] },
  ],
};

const barOption = {
  title: { text: "Bar Chart", textStyle: { color: '#fff' } },
  tooltip: { backgroundColor: '#222', textStyle: { color: '#fff' }, borderColor: '#fff' },
  xAxis: { data: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"], axisLabel: { color: '#fff' }, axisLine: { lineStyle: { color: '#fff' } } },
  yAxis: { axisLabel: { color: '#fff' }, axisLine: { lineStyle: { color: '#fff' } } },
  series: [
    { name: "uv", type: "bar", data: [4000, 3000, 2000, 2780, 1890, 2390, 3490] },
    { name: "pv", type: "bar", data: [2400, 1398, 9800, 3908, 4800, 3800, 4300] },
  ],
};

const areaOption = {
  title: { text: "Area Chart", textStyle: { color: '#fff' } },
  tooltip: { backgroundColor: '#222', textStyle: { color: '#fff' }, borderColor: '#fff' },
  xAxis: { data: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"], axisLabel: { color: '#fff' }, axisLine: { lineStyle: { color: '#fff' } } },
  yAxis: { axisLabel: { color: '#fff' }, axisLine: { lineStyle: { color: '#fff' } } },
  series: [
    { name: "uv", type: "line", areaStyle: {}, data: [4000, 3000, 2000, 2780, 1890, 2390, 3490] },
    { name: "pv", type: "line", areaStyle: {}, data: [2400, 1398, 9800, 3908, 4800, 3800, 4300] },
  ],
};

const pieOption = {
  title: { text: "Pie Chart", textStyle: { color: '#fff' } },
  tooltip: { trigger: "item", backgroundColor: '#222', textStyle: { color: '#fff' }, borderColor: '#fff' },
  legend: { top: "5%", left: "center", textStyle: { color: '#fff' } },
  series: [
    {
      name: "Groups",
      type: "pie",
      radius: ["40%", "70%"],
      avoidLabelOverlap: false,
      itemStyle: { borderRadius: 10, borderColor: "#fff", borderWidth: 2 },
      label: { show: false, position: "center", color: '#fff' },
      emphasis: { label: { show: true, fontSize: 18, fontWeight: "bold", color: '#fff' } },
      labelLine: { show: false, lineStyle: { color: '#fff' } },
      data: [
        { value: 400, name: "Group A" },
        { value: 300, name: "Group B" },
        { value: 300, name: "Group C" },
        { value: 200, name: "Group D" },
      ],
    },
  ],
};

const EchartsTestPage = () => (
  <div style={{ padding: 24 }}>
    <Typography variant="h4" gutterBottom>ECharts Test Page</Typography>
    <div style={{ width: "100%", height: 350 }}>
      <ReactECharts option={lineOption} style={{ height: 300 }} />
    </div>
    <div style={{ width: "100%", height: 350, marginTop: 40 }}>
      <ReactECharts option={barOption} style={{ height: 300 }} />
    </div>
    <div style={{ width: "100%", height: 350, marginTop: 40 }}>
      <ReactECharts option={areaOption} style={{ height: 300 }} />
    </div>
    <div style={{ width: "100%", height: 350, marginTop: 40 }}>
      <ReactECharts option={pieOption} style={{ height: 300 }} />
    </div>
  </div>
);

export default EchartsTestPage;